/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

/**
 * Avatar 사용자 Profile의 기본 이미지 리소스
 */
import img_default_guest_24x24 from "@/assets/images/avatar/img_default_guest_24x24.png";

import img_default_profile_14x14 from "@/assets/images/avatar/img_default_profile_14x14.png";
import img_default_profile_19x19 from "@/assets/images/avatar/img_default_profile_19x19.png";
import img_default_profile_24x24 from "@/assets/images/avatar/img_default_profile_24×24.png";
import img_default_profile_32x32 from "@/assets/images/avatar/img_default_profile_32x32.png";
import img_default_profile_40x40 from "@/assets/images/avatar/img_default_profile_40x40.png";
import img_default_profile_60x60 from "@/assets/images/avatar/img_default_profile_60x60.png";
import img_default_profile_80x80 from "@/assets/images/avatar/img_default_profile_80x80.png";
import img_default_profile_new from "@/assets/images/avatar/img_default_profile.svg";

/**
 * Avatar내 사용자 Profile 이미지 외 기본 리소스
 */
import img_default_14x14 from "@/assets/images/avatar/img_default_14x14.png";
import img_default_19x19 from "@/assets/images/avatar/img_default_19x19.png";
import img_default_24x24 from "@/assets/images/avatar/img_default_24x24.png";
import img_default_32x32 from "@/assets/images/avatar/img_default_32x32.png";
import img_default_40x40 from "@/assets/images/avatar/img_default_40x40.png";
import img_default_60x60 from "@/assets/images/avatar/img_default_60x60.png";
import img_default_64x64 from "@/assets/images/avatar/img_default_64x64.png";

export default {
	img_default_guest_24x24,
	img_default_profile_14x14,
	img_default_profile_19x19,
	img_default_profile_24x24,
	img_default_profile_32x32,
	img_default_profile_40x40,
	img_default_profile_60x60,
	img_default_profile_80x80,
	img_default_profile_new,
	img_default_14x14,
	img_default_19x19,
	img_default_24x24,
	img_default_32x32,
	img_default_40x40,
	img_default_60x60,
	img_default_64x64
};
